<template>
    <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white p-4 rounded shadow-lg w-full max-w-2xl">
        <h2 class="text-lg font-bold mb-4">Crop Image</h2>
        <cropper ref="cropper" :src="imageUrl" :aspect-ratio="9/16" :view-mode="1" style="height: 400px; width: 100%;" />
        <div class="mt-4 flex justify-end space-x-2">
          <!-- <button @click="emitCrop" class="bg-blue-500 hover:bg-blue-600  py-2 px-4 rounded">Crop & Save</button>
          <button @click="$emit('cancel')" class="bg-gray-500 hover:bg-gray-600  py-2 px-4 rounded">Cancel</button> -->

        <CButton @click="emitCrop" size="sm" color="primary">
            <CIcon name="cil-check-circle" /> Crop & Save
        </CButton>
        <CButton class="ml-2" color="danger" size="sm" @click="$emit('cancel')">
            <CIcon name="cil-ban" /> {{ $lang.buttons.general.crud.cancel }}
        </CButton>

        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Cropper from 'vue-cropperjs';
  import 'cropperjs/dist/cropper.css';
  
  export default {
    name: 'CropModal',
    components: { Cropper },
    props: {
      imageUrl: {
        type: String,
        required: true,
      },
    },
    methods: {
      emitCrop() {
        const cropped = this.$refs.cropper.getCroppedCanvas().toDataURL();
        this.$emit('crop', cropped);
      }
    }
  };
  </script>
  
  <style scoped>
  /* Modal Overlay styles are already included */
  </style>